var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyrightBox"},[_vm._v(" "+_vm._s(_vm.$t('message.tabs.bottom'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }